import {useRef} from 'react'

import StepWizard from 'react-step-wizard'

import Nav from './Nav'
import {BuildingDetails} from "./wizard/BuildingDetails";
import {BuildingTypeSelection} from "./wizard/BuildingTypeSelection";
import {MeterDetails} from "./wizard/MeterDetails";
import {Summary} from "./wizard/Summary";

/**
 * Planner wizard component.
 */
const Wizard = () => {
  const topRef = useRef<HTMLDivElement>(null)

  const onStepChange = () => {
    /* istanbul ignore next */
    if (window.scrollY > (topRef?.current?.offsetTop ?? 0)) {
      topRef?.current?.scrollIntoView({behavior: 'smooth'})
    }
  }

  return (
    <div className='container'>
      <div className='jumbotron'>
        <div className='row' ref={topRef}>
          <div className='col-12 mb-4'>
            <StepWizard
              onStepChange={onStepChange}
              nav={<Nav/>}
            >
              <BuildingTypeSelection/>
              <BuildingDetails/>
              <MeterDetails/>
              <Summary/>
            </StepWizard>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Wizard
